/* eslint-disable max-len */
export default {
  Settings: {
    SettingsDescription: 'Contact',
    Contact: {
      Title: 'Contact',
      Copy: 'Copy',
      Delete: 'Delete',
      CreateNew: {
        Action: 'Add new contact',
        ContactType: 'Contact type',
        ContactDetail: 'Contact detail',
        ContactTypeExample: {
          Email: 'Email',
          PhoneNumber: 'Phone number',
          EmergencyContact: 'Emergency contact',
        },
      },
    },
    Auth: {
      Title: 'Authentication',
      SetupAuth: 'Setup authentication',
      ReactivateAuth: 'Reactivate authentication',
      RemoveAuth: 'Remove authentication',
      ResetPassword: 'Reset password',
      Email: 'Login email',
      Password: 'Password',
      RePassword: 'Re-enter Password',
      ReactivateAuthText: 'Would you like to reactivate their authentication?',
      Status: {
        Title: 'Status',
        UNCONFIRMED: 'User created but not confirmed.',
        CONFIRMED: 'User confirmed.',
        UNKNOWN: 'User status unknown.',
        RESET_REQUIRED: 'Confirmed, must change temporary password on first sign-in.',
        FORCE_CHANGE_PASSWORD: 'Confirmed, must change temporary password on first sign-in.',
        DEACTIVATED: 'User authentication deactivated',
      },
    },
  },
  Correspondance: {
    Title: 'Correspondance',
    Filter: 'Filter',
    Header: {
      Description: 'Description',
      LastAnnouncement: 'Last announcement',
    },
    Type: {
      Comments: 'Comments',
      Announcements: 'Announcements',
      Logs: 'Logs',
    },
    Sort: {
      NewestFirst: 'Newest first',
      OldestFirst: 'Oldest first',
    },
    NewMessage: {
      Comments: 'Comments',
      Announcements: 'Announce',
      Cancel: 'Cancel',
      AddACommentOrAnnouncements: 'Add a comment or announcement',
    },
    Correspondance: {
      AnnouncedOn: 'Announced on',
      CommentedOn: 'Commented on',
      Logs: {
        CreatedOn: 'Created caregiver on',
        EditName: 'Edited name on',
        EditDescription: 'Edited description on',
        EditStatus: 'Edited status on',
        EditPhoto: 'Edited photo on',
        EditContact: 'Added contact on',
        RemoveContact: 'Removed contact on',
      },
    },
    Messages: {
      LoadMore: 'Load more',
    },
    Logs: {
      EditContact: {
        Text: `#{type} added: #{detail}`,
      },
      RemoveContact: {
        Text: `#{type} removed: #{detail}`,
      },
      EditStatus: {
        Text: `Status changed from #{oldStatus} to #{newStatus}`,
      },
      EditName: {
        Text: `Caregiver name changed from #{oldCaregiverName} to #{newCaregiverName}`,
      },
    },
  },
  Biography: {
    Title: 'Biography',
    Categories: {
      personalInfo: 'Personal Information',
      contactInfo: 'Contact Information',
      workQuali: 'Work Qualifications',
      workExperience: 'Work Experience',
      availability: 'Availability',
      skillsAndPrefs: 'Skills and Preferences',
      agreements: 'Agreements',
    },
    Questions: {
      Actions: {
        Delete: 'Delete Question',
      },
      Titles: {
        name: 'Name',
        email: 'Email',
        phoneNumber: 'Phone number',
        profilePhoto: 'Profile photo',
        currentCity: 'Current city',
        homeLocation: 'Home location',
        caregiverType: 'Caregiver type',
        educationCertificate: 'Education certificate',
        yearsOfExperience: 'Years of experience',
        mondayShifts: 'Monday shifts',
        tuesdayShifts: 'Tuesday shifts',
        wednesdayShifts: 'Wednesday shifts',
        thursdayShifts: 'Thursday shifts',
        fridayShifts: 'Friday shifts',
        saturdayShifts: 'Saturday shifts',
        sundayShifts: 'Sunday shifts',
        certified: 'Certified',
        termsAgreement: 'Terms agreement',
        emergencyContact: 'Emergency contact',
        otherCertifications: 'Other certifications',
        languagesSpoken: 'Languages spoken',
        minDesiredShiftLength: 'Minimum shift length',
        commutePref: 'Commute preference',
        cookingSkills: 'Cooking skills',
        housekeepingSkills: 'Housekeeping skills',
        prefRateOfPay: 'Rate of pay',
        vulnerableSectorCheck: 'Vulnerable sector check',
        caregiverMotivation: 'Caregiver motivation',
        shortBio: 'Short bio',
        personalBio: 'Personal bio',
        professionalBio: 'Professional bio',
        resume: 'Resume',
        refName: 'Reference name',
        refRelationship: 'Reference relationship',
        emergencyContactName: 'Emergency contact name',
        emergencyContactRelationship: 'Emergency contact relationship',
        emergencyContactPhone: 'Emergency contact phone number',
        refPhone: 'Reference phone number',
        isProfOrgMember: 'I understand that I must be a member of a professional organization to work at CareQuilt',
        certifiesTruthfulness: 'Do you certify that all information provided in this application is truthful and accurate to the best of your knowledge?',
        understandsPrivacyAndAgreesToConfidentialityPolicies: 'Do you understand the importance of maintaining client privacy and confidentiality, and agree to adhere to all confidentiality policies?',
        certifiesValidAndUpToDateCertifications: 'Do you certify that all training certificates and qualifications listed in this application are valid and current?',
        understandsAbuseProhibition: 'Do you understand that abuse, neglect, or exploitation of any kind toward clients is strictly prohibited and grounds for legal action?',
        committedToCodeOfConductAndEthics: 'Do you commit to following the organization\'s code of conduct and ethical standards in all interactions with clients, families, and fellow staff members?',
        emergencyContacts: 'Emergency contact',
        emergencyContacts_name: 'Name',
        emergencyContacts_relationship: 'Relationship',
        emergencyContacts_phoneNumber: 'Phone number',
        references: 'Reference',
        references_name: 'Name',
        references_phoneNumber: 'Phone number',
        references_relationship: 'Relationship',
        references_email: 'Email',
      },
      Options: {
        caregiverType: {
          PSW: 'PSW',
          DSW: 'DSW',
          nursingStudent: 'Nursing Student',
          unaccredited: 'Unaccredited',
        },
        languagesSpoken: {
          english: 'English',
          french: 'French',
          spanish: 'Spanish',
          igbo: 'Igbo',
          portugese: 'Portugese',
          italian: 'Italian',
          greek: 'Greek',
          hindi: 'Hindi',
          punjabi: 'Punjabi',
          mandarin: 'Mandarin',
          cantonese: 'Cantonese',
        },
        mondayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        tuesdayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        wednesdayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        thursdayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        fridayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        saturdayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        sundayShifts: {
          morning: 'Mornings (6am-12pm)',
          afternoon: 'Afternoons (12pm-5pm)',
          evening: 'Evenings (5pm-9pm)',
          night: 'Nights (9pm-6am)',
          unavailable: 'Unavailable',
        },
        commutePref: {
          '5km': 'Up to 5 km',
          '10km': 'Up to 10 km',
          '25km': 'Up to 25 km',
          '50km': 'Up to 50 km',
          'over50': 'Over 50 km',
        },
      },
      Empty: 'N/A',
    },
    Export: 'Export Caregiver',
    EditQuestion: {
      File: {
        UploadFile: 'Drop or browse new files',
      },
    },
  },
  Scheduling: {
    Title: 'Scheduling',
    AddNewSchedule: 'Add new schedule',
    ScheduleSetupWizard: 'Schedule setup wizard',
    ScheduleDetail: {
      Action: {
        Back: 'Back',
        Next: 'Next',
        Review: 'Review',
        Create: 'Create',
      },
      SelectEventType: {
        Title: 'Event type',
        FixedEventTitle: 'Fixed Event',
        FixedEventExplain: 'Schedule this as a one-time event for a specific date and time.',
        RecurringEventTitle: 'Recurring Event',
        RecurringEventExplain: 'Set this event to repeat on a regular basis (e.g., daily, weekly, or monthly).',
      },
      EventInfo: {
        Title: 'Event name',
        Description: 'Description',
        NoDescription: 'No description',
      },
      EventDate: {
        FixedEvent: {
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
        },
        RecurrenceEvent: {
          StartDate: 'Start date',
          EndDate: 'End date',
          EndDateDisplay: 'End date or leave blank for infinity',
          Infinity: 'Infinity',
          Frequency: 'Frequency',
          FrequencyData: {
            DAILY: 'Daily',
            WEEKLY: 'WEEKLY',
            MONTHLY: 'MONTHLY',
            YEARLY: 'YEARLY',
          },
          Interval: 'Interval',
          StartTime: 'Start time',
          EndTime: 'End time',
          Timezone: 'Timezone',
          DayOfTheWeek: {
            SU: 'S',
            MO: 'M',
            TU: 'T',
            WE: 'W',
            TH: 'T',
            FR: 'F',
            SA: 'S',
          },
          ByMonthDay: `By Month Day (e.g., 25)`,
          ByMonth: `By Month (e.g., 11)`,
        },
      },
      Client: {
        ClientName: 'Client',
      },
    },
  },
  ClientConnections: {
    Title: 'Clients',
    AddClient: {
      Title: 'Add client to roster',
      ClientSearch: 'Client',
      AddClient: 'Add client',
    },
    Client: {
      ClientName: 'Client name',
    },
  },
  ChangeStatusDailog: {
    Title: 'Change status',
    Status: 'Status',
  },
  ChangeName: {
    Title: 'Change name',
    Name: 'Name',
  },
  Payment: {
    Title: 'Payment',
    PaymentPlan: {
      Title: 'Payment details',
      HourlyRateTitle: 'Hourly rate',
      HourlyCost: '$#{hourlyRate}',
      NoHourlyRate: 'Hourly rate not set',
    },
    PaymentSlip: {
      Title: 'Payment slip',
    },
    WeekOf: `Week of #{date} #{status}`,
    HoursDisplay: `#{hours} hrs`,
    CostDisplay: `$#{cost}`,
    WaitingConfirmation: 'Waiting confirmation',
    Complete: 'Complete',
    WorkSummary: {
      Title: 'Work summary',
      TotalHours: 'Total Hours',
      TotalCost: 'Total Cost',
      ConfirmedHours: 'Confirmed Hours',
      ConfirmedCost: 'Confirmed Cost',
      HoursWorked: {
        Title: 'Hours worked',
        ShiftTile: `Shift tile: #{title}`,
        ShiftTime: `Shift from #{startTime} #{endTime}`,
        ConfirmationYes: `Confirmation: ✔`,
        ConfirmationNo: `Confirmation: ✘`,
      },
    },
  },
};
